/**
 * Maximum Graphics – chat widget (goes in your Shopify theme)
 * ------------------------------------------------------------------
 * Add to Shopify: Online Store → Themes → ⋯ → Edit code → Assets →
 * "Add a new asset" → upload this file. Then add ONE line to
 * layout/theme.liquid, just above </body>:
 *
 *   <script src="{{ 'mg-chat-widget.js' | asset_url }}"
 *     data-endpoint="https://YOUR-WORKER.workers.dev"
 *     data-contact-url="/pages/contact" defer></script>
 *
 * data-endpoint    = your Cloudflare Worker URL (Step 2 of the README)
 * data-contact-url = the link to your Contact page
 *
 * This file holds NO API key. It only talks to your Worker.
 */
(function () {
  var script = document.currentScript;
  var ENDPOINT = script && script.getAttribute("data-endpoint");
  var CONTACT_URL = (script && script.getAttribute("data-contact-url")) || "/pages/contact";
  if (!ENDPOINT) {
    console.warn("MG chat: data-endpoint is missing on the script tag.");
    return;
  }

  var GREETING =
    "Hi! Ask me about DTF transfers, UV DTF, DTG or embroidery. " +
    "For a custom quote, use our Contact form and we'll reply within 1 business day.";

  var history = []; // conversation lives only in this browser tab
  var busy = false;

  /* ---------- styles ---------- */
  var css =
    "#mgc-btn{position:fixed;right:20px;bottom:20px;z-index:99999;width:60px;height:60px;border-radius:50%;border:0;background:#111;color:#fff;font-size:26px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.25)}" +
    "#mgc-box{position:fixed;right:20px;bottom:92px;z-index:99999;width:360px;max-width:calc(100vw - 32px);height:520px;max-height:calc(100vh - 120px);background:#fff;color:#111;border-radius:14px;box-shadow:0 8px 30px rgba(0,0,0,.25);display:none;flex-direction:column;overflow:hidden;font:15px/1.4 system-ui,-apple-system,Segoe UI,Roboto,sans-serif}" +
    "#mgc-box.open{display:flex}" +
    "#mgc-head{background:#111;color:#fff;padding:12px 14px;display:flex;justify-content:space-between;align-items:center}" +
    "#mgc-head b{font-size:15px}#mgc-head small{display:block;opacity:.75;font-size:12px}" +
    "#mgc-x{background:none;border:0;color:#fff;font-size:22px;cursor:pointer}" +
    "#mgc-log{flex:1;overflow-y:auto;padding:12px;background:#f6f6f6}" +
    ".mgc-m{max-width:85%;padding:9px 12px;border-radius:12px;margin:6px 0;white-space:pre-wrap;word-wrap:break-word}" +
    ".mgc-bot{background:#fff;border:1px solid #e3e3e3}" +
    ".mgc-user{background:#111;color:#fff;margin-left:auto}" +
    ".mgc-typing{opacity:.6;font-style:italic}" +
    "#mgc-form{display:flex;border-top:1px solid #e3e3e3}" +
    "#mgc-in{flex:1;border:0;padding:12px;font:inherit;outline:none}" +
    "#mgc-send{border:0;background:#111;color:#fff;padding:0 16px;cursor:pointer;font:inherit}" +
    "#mgc-send:disabled{opacity:.5}" +
    "#mgc-foot{font-size:11px;color:#666;padding:6px 12px;border-top:1px solid #eee;background:#fff}" +
    "#mgc-foot a{color:#111}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- layout ---------- */
  var btn = el("button", { id: "mgc-btn", "aria-label": "Open chat" }, "💬");
  var box = el("div", { id: "mgc-box", role: "dialog", "aria-label": "Maximum Graphics chat" });
  var head = el("div", { id: "mgc-head" });
  var title = el("div");
  title.appendChild(el("b", null, "Maximum Graphics"));
  title.appendChild(el("small", null, "AI assistant"));
  var closeBtn = el("button", { id: "mgc-x", "aria-label": "Close chat" }, "×");
  head.appendChild(title);
  head.appendChild(closeBtn);

  var log = el("div", { id: "mgc-log", "aria-live": "polite" });
  var form = el("form", { id: "mgc-form" });
  var input = el("input", { id: "mgc-in", type: "text", placeholder: "Type your question…", maxlength: "1000", autocomplete: "off" });
  var send = el("button", { id: "mgc-send", type: "submit" }, "Send");
  form.appendChild(input);
  form.appendChild(send);

  var foot = el("div", { id: "mgc-foot" });
  foot.appendChild(document.createTextNode("AI answers can be wrong. For quotes or order help, use our "));
  foot.appendChild(el("a", { href: CONTACT_URL }, "Contact form"));
  foot.appendChild(document.createTextNode("."));

  box.appendChild(head);
  box.appendChild(log);
  box.appendChild(form);
  box.appendChild(foot);
  document.body.appendChild(box);
  document.body.appendChild(btn);

  addMsg("assistant", GREETING, false);

  /* ---------- events ---------- */
  btn.addEventListener("click", function () {
    box.classList.toggle("open");
    if (box.classList.contains("open")) input.focus();
  });
  closeBtn.addEventListener("click", function () {
    box.classList.remove("open");
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;
    input.value = "";
    addMsg("user", text, true);
    ask();
  });

  /* ---------- talk to the Worker ---------- */
  function ask() {
    busy = true;
    send.disabled = true;
    var typing = el("div", { class: "mgc-m mgc-bot mgc-typing" }, "Typing…");
    log.appendChild(typing);
    scroll();

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: history }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        typing.remove();
        addMsg("assistant", data.reply || "Sorry, something went wrong. Please use our Contact form.", true);
      })
      .catch(function () {
        typing.remove();
        addMsg("assistant", "Sorry, I can't connect right now. Please use our Contact form.", false);
      })
      .finally(function () {
        busy = false;
        send.disabled = false;
        input.focus();
      });
  }

  /* ---------- helpers ---------- */
  function addMsg(role, text, remember) {
    // textContent (not innerHTML) so no one can inject code into the page
    log.appendChild(el("div", { class: "mgc-m " + (role === "user" ? "mgc-user" : "mgc-bot") }, text));
    if (remember) history.push({ role: role, content: text });
    scroll();
  }
  function scroll() {
    log.scrollTop = log.scrollHeight;
  }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }
})();